module.exports = __webpack_public_path__ + "static/media/Wynaut_gaussian2.b0f94106.png";